import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const CookieBanner = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem("cookieAccepted");
        if (!accepted) {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookieAccepted", "true");
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 w-full px-4">
            <div className="flex flex-wrap sm:flex-nowrap items-start sm:items-center justify-between gap-4 rounded-2xl bg-white shadow-xl px-4 py-4 sm:px-6 sm:py-4 w-full max-w-3xl mx-auto">
                {/* Cookie Icon */}
                <div className="text-2xl">🍪</div>

                {/* Message */}
                <p className="text-gray-800 text-sm flex-1 text-left min-w-[200px]">
                    We use cookies to enhance your experience and improve site performance. By continuing
                    without updating your preferences, you agree to our cookie policy.
                </p>

                {/* Buttons */}
                <div className="w-full sm:w-auto flex justify-center sm:justify-end items-center gap-2">
                    <button
                        onClick={handleAccept}
                        className="bg-purple-600 text-white text-sm px-4 py-2 rounded-md hover:bg-purple-700 transition whitespace-nowrap"
                    >
                        Accept
                    </button>
                    <button
                        onClick={() => setShowBanner(false)}
                        className="text-gray-600 hover:text-black"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
